import ErrorPage from "@/pages/error/ErrorPage";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ErrorBoundary } from "react-error-boundary";
import "./index.css";
import { CURRENT_LOCALE, initTranslations } from "./locales";

const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  const messages = {
    en: "Please wait...",
    ro: "Vă rugăm să așteptați...",
    ru: "Пожалуйста, подождите...",
    es: "Por favor, espere...",
    fr: "Veuillez patienter...",
    de: "Bitte warten...",
    it: "Per favore, attendi...",
  };
  root.render(
    <div className="loading-placeholder-page">
      {messages[CURRENT_LOCALE as keyof typeof messages] ?? messages.en}
    </div>,
  );

  // eslint-disable-next-line no-console
  if (import.meta.env.DEV) console.time("init");

  // Translation strings must be loaded before the rest of the app can be
  // loaded or else top-level use of translation strings will fail.
  await initTranslations();

  // eslint-disable-next-line no-console
  if (import.meta.env.DEV) console.timeLog("init", "translations loaded");

  const { default: App } = await import("./App");

  // eslint-disable-next-line no-console
  if (import.meta.env.DEV) console.timeLog("init", "app loaded");

  root.render(
    <StrictMode>
      <ErrorBoundary
        fallbackRender={({ error, resetErrorBoundary }) => (
          <ErrorPage
            errorCode={500}
            errorStatus={(error as Error).message}
            resetErrorBoundary={resetErrorBoundary}
          />
        )}
      >
        <App />
      </ErrorBoundary>
    </StrictMode>,
  );

  // eslint-disable-next-line no-console
  if (import.meta.env.DEV) console.timeEnd("init");
}
